module.exports = __webpack_public_path__ + "img/rpjh.c3052292.png";